<template>
	<div id="cs-logincallback container-fluid"></div>
</template>
<script type="text/javascript">
/**
 * Login page component
 *
 * @version 1.0.0
 * @since 1.0.0
 */
export default {
	name : 'CsLogincallback',

	created() {
		this.signinRedirectCallback();
	},

	methods: {
		signinRedirectCallback() {
			this.$auth
				.getUserManager()
				.signinRedirectCallback()
				.then((user) => {

					this.$emit('setupSession', user);
					this.createSessionLog(user);

					const redirectAfterLogin = localStorage.getItem('redirectAfterLogin');

					if ( redirectAfterLogin ) {
						localStorage.removeItem('redirectAfterLogin');

						this.$router.push(redirectAfterLogin);
					} else {
						this.$router.push({ name: 'home', params : { entityorscreen : 'home' } });
					}
				}).catch((error) => {
					this.$recordError({
						type : 'error',
						error : error,
						displayToUser : false,
						errorCode : '000142'
					});
					// hack to handle stale state being bookmarked by users, redirect them back through auth which then works(?)
					if (error == 'Error: No matching state found in storage') {
						this.$router.replace('/');
					}
				});
		},

		/**
		 * @public
		 * @description
		 * Makes a log of the successful sign in
		 *
		 * @param user
		 */
		createSessionLog(user) {
			// eslint-disable-next-line eqeqeq
			if (user == undefined) {
				// should never happen, catch it just in case
				this.$recordError({
					type: 'warning',
					error: new Error(`User is ${typeof user}`),
					displayToUser: false,
					errorCode: '000309'
				});
			}
			this.$axios
				.post(`${this.$getApiBaseUrl()}/api/activitylog/createlog`, {
					userId: user.profile.Id
				})
				.catch((error) => {
					this.$recordError({
						type: 'warning',
						error: error,
						displayToUser: false,
						errorCode: '000202'
					});
				});
		}
	}
}
</script>
